export default __webpack_public_path__ + "static/media/square.32878a0e.png";